import React from 'react'
import Swal from 'sweetalert2'
import Constant from '../../Constant.js'
import axios from 'axios'
import ReactQuill from 'react-quill'
import Button from '../../common/CustomComponents/Button.js'

class HistoryAdd extends React.Component {
  state = {
    android_version: '',
    ios_version: '',
    content_en: '',
    content_ar: '',
    img: '',
    title_en: '',
    title_ar: '',
    image: '',
    isSaving: false,
    isData: false,
    Edit: false,
  }

  componentDidMount() {
    setTimeout(() => {
      if (this.props.id) {
        this.getHistoryDetails()
      }
    }, 100)
  }

  getHistoryDetails = async () => {
    await axios
      .get(Constant.getAPI() + `/version-history/get-history-details/${this.props.id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          this.setState({ ...res.data.data })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value })
  }

  handleContentChangeEn = (value) => {
    this.setState({
      content_en: value,
    })
  }

  handleContentChangeAr = (value) => {
    this.setState({
      content_ar: value,
    })
  }

  handleChangeImage = (e) => {
    this.setState({ [e.target.name]: e.target.files[0] })
    this.setState({ Edit: false })
    this.setState({ image: URL.createObjectURL(e.target.files[0]) })
  }

  onSaveData = () => {
    var that = this

    const formData = new FormData()

    formData.append('android_version', this.state.android_version)
    formData.append('ios_version', this.state.ios_version)
    formData.append('title_en', this.state.title_en)
    formData.append('title_ar', this.state.title_ar)
    formData.append('content_en', this.state.content_en)
    formData.append('content_ar', this.state.content_ar)

    that.setState({ isData: true })

    if (this.props.id) {
      formData.append('id', this.props.id)

      if (this.state.img?.name) {
        formData.append('img', this.state.img)
      }

      axios
        .put(Constant.getAPI() + '/version-history/update-version-history', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then((res) => {
          this.setState({ isData: false })
          if (res.status === 200) {
            Swal.fire('Updated !', `Record has been Updated`, 'success')
            window.history.back()
          }
        })
        .catch((err) => {
          this.setState({ isData: false })
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
    } else {
      formData.append('img', this.state.img)

      axios
        .post(Constant.getAPI() + '/version-history/add-version-history', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then((res) => {
          that.setState({ isData: false })
          if (res.status === 200) {
            Swal.fire('Added !', `Record has been Added`, 'success')
            window.history.back()
          }
        })
        .catch((err) => {
          this.setState({ isData: false })
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
    }
  }

  render() {
    return (
      <div className="">
        <div className="card-body">
          <div className="row">
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Android Version</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    name="android_version"
                    id="android_version"
                    placeholder={`Android Version`}
                    onChange={this.handleChange}
                    value={this.state.android_version}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">IOS Version</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    name="ios_version"
                    id="ios_version"
                    placeholder={`IOS Version`}
                    onChange={this.handleChange}
                    value={this.state.ios_version}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Title: English</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    name="title_en"
                    id="title_en"
                    placeholder={`Title: English`}
                    maxLength={50}
                    onChange={this.handleChange}
                    value={this.state.title_en}
                  />
                </div>
                <div className="col-sm-12 text-right">{this.state.title_en.length + ' / 50'}</div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Title: Arabic</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    name="title_ar"
                    id="title_ar"
                    placeholder={`Title: Arabic`}
                    maxLength={50}
                    onChange={this.handleChange}
                    value={this.state.title_ar}
                  />
                </div>
                <div className="col-sm-12 text-right">{this.state.title_ar.length + ' / 50'}</div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Content: English</label>
                <div className="col-sm-9">
                  <ReactQuill
                    name="content_en"
                    id="content_en"
                    value={this.state.content_en}
                    onChange={this.handleContentChangeEn}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Content: Arabic</label>
                <div className="col-sm-9">
                  <ReactQuill
                    name="content_ar"
                    id="content_ar"
                    value={this.state.content_ar}
                    onChange={this.handleContentChangeAr}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="row">
                <div className="col-sm-3">Image</div>
                <div className="col-sm-6">
                  <div className="form-group">
                    <div>
                      <input
                        type="file"
                        id="img"
                        name="img"
                        accept="image/*"
                        className="w-100"
                        onChange={this.handleChangeImage}
                      />
                    </div>
                  </div>
                  {!this.state.image ? (
                    <img
                      width="250px"
                      height="200px"
                      src={Constant.getImage() + this.state.img}
                      alt="img"
                      onError={(event) => {
                        event.currentTarget.src = './assets/images/no_image.png'
                      }}
                    />
                  ) : (
                    <img
                      width="250px"
                      height="200px"
                      src={this.state.image}
                      alt="img"
                      onError={(event) => {
                        event.currentTarget.src = './assets/images/no_image.png'
                      }}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12 text-right">
              <Button
                disabled={this.state.isData}
                onClick={this.onSaveData}
                startIcon={<i className="icofont icofont-save"></i>}
              >
                Save
              </Button>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default HistoryAdd
